/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/TagsIndex/theme';

export const TagsIndexTheme = theme;
